import styled, { css } from 'styled-components';

import { ColorName } from 'types';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { DetailLabel, DetailMuted, DetailValue } from '../OrderAddressBlocks.styles';
import { FIELD_LABEL_HEIGHT } from '../layout';

const Picker = styled.div<{ $color?: ColorName }>`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;

  /* Catalogue colour (black / red / blue) on the text, arrows and icons, as in the mockup. */
  ${({ $color }) =>
    $color &&
    css`
      label,
      button[aria-expanded],
      [class*='singleValue'],
      [class*='placeholder'],
      [class*='indicatorContainer'],
      ${DetailLabel}, ${DetailValue}, ${DetailMuted} {
        color: ${pickColor($color)};
      }
    `};
`;

/** Name select in the name column: it has no label, so it lines up with the code box. */
const NameSlot = styled.div`
  margin-top: ${FIELD_LABEL_HEIGHT};

  [class*='singleValue'] {
    font-weight: 700;
  }

  ${mediaMinWidth.sm(css`
    margin-top: 0;
  `)};
`;

export { NameSlot, Picker };
